<section class="contenedor_banner" [ngClass]="obtenerEstiloBanner() || ''">
    <article class="contenedor_banner_mensaje">
        <ng-content></ng-content>
        @if (!!contador && !mensaje) {
            <ng-container *ngTemplateOutlet="contenedor_contador; context: { estado: this.estadoContador }"></ng-container>
        }
        @if (!!mensaje && !contador) {
            <span class="banner_mensaje">{{mensaje}}</span>
        }
        @if (!ocultaCierre) {
            <span class="material-icons icono_cierre_banner" 
                style="font-size: 26px; cursor: pointer;"
                (click)="ocultaBanner = true">
                close
            </span>
        }        
    </article>
</section>

<ng-template #contenedor_contador let-estado="estado">
    <ng-container [ngSwitch]="estado">
        <ng-container *ngSwitchCase="tipoEstadoContador.ACTUALIZAR">
            <ng-container *ngTemplateOutlet="contenedor_renueva_subscripcion;"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="tipoEstadoContador.ACTUALIZA_V2">
            <ng-container *ngTemplateOutlet="contenedor_renueva_subscripcion;"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="tipoEstadoContador.RELOJ">
            <ng-container *ngTemplateOutlet="contenedor_contador_reloj"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="tipoEstadoContador.EXPIRADO">
            <div class="banner_expirado">
                <div class="banner_expirado_izquierda">
                    <div class="banner_expirado_header">
                        <img src="assets/media/svg/info-banner.svg" alt="alerta" class="banner_expirado_icono">
                        <span class="banner_expirado_titulo">Renueva tu suscripción para seguir trabajando</span>
                    </div>
                    <span class="banner_expirado_descripcion">
                        Tu cuenta venció el {{fechaExpiracionEmpresa | date: 'dd-MM-yyyy'}}.
                        Tus datos y documentos siguen guardados; el acceso se restablece al confirmarse el pago.
                    </span>
                    <div class="banner_expirado_badge">
                        <img src="assets/media/svg/calendario-exclamacion-orange.svg" alt="fecha" class="banner_expirado_badge_icono">
                        <span>Vencida el <b>{{fechaExpiracionEmpresa | date: 'dd-MM-yyyy'}}</b></span>
                    </div>
                </div>
                <div class="banner_expirado_derecha">
                    <button class="banner_expirado_boton" (click)="onPagarEnLinea()">Pagar en línea</button>
                </div>
            </div>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #contenedor_contador_reloj>
    <span>Tu suscripción vence en </span>
    <div id="contenedor_contador">
        <div class="contenedor_contador_etiqueta_numero">
            <small>Dias</small>
            <p>00</p>
        </div>
        <div class="contenedor_contador_etiqueta_numero">
            <small>Horas</small>
            <p>00</p>
        </div>
        <div class="contenedor_contador_etiqueta_numero">
            <small>Min</small>
            <p>00</p>
        </div>
        <div class="contenedor_contador_etiqueta_numero">
            <small>Seg</small>
            <p>00</p>
        </div>
    </div>
    <span>Para mantenerla activa <b><u>Suscríbete ahora</u></b></span>
</ng-template>

<ng-template #contenedor_renueva_subscripcion>
    <span class="material-icons" style="font-size: 26px;">info</span>
    <span> Recuerda que tu suscripción vence el día {{fechaExpiracionEmpresa | date: 'dd-MM-yyyy'}}. Para mantenerla activa debes renovar tu suscripción antes de esa fecha. </span>
</ng-template>
